import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/arrow-left-dot-pagination.svg.js';
import img$1 from '../../../../assets/images/arrow-right-dot-pagination.svg.js';
import css_248z from './carousel-dot-navigation.scss.js';

class CarouselDotNavigation extends s {
    constructor() {
        super(...arguments);
        this.nextText = '';
        this.previousText = '';
    }
    render() {
        return x `<div class="swiper-nav ${this.rtl || isRTL() ? 'rtl' : ''}"><icon-button class="swiper-button-prev" styleType="" ariaLabel="${this.previousText}"><img slot="icon" src="${img}" alt="" aria-hidden="true"></icon-button><div class="swiper-pagination"></div><icon-button class="swiper-button-next" styleType="" ariaLabel="${this.nextText}"><img slot="icon" src="${img$1}" alt="" aria-hidden="true"></icon-button></div>`;
    }
}
CarouselDotNavigation.styles = css_248z;
__decorate([
    n({ type: Boolean })
], CarouselDotNavigation.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], CarouselDotNavigation.prototype, "nextText", void 0);
__decorate([
    n({ type: String })
], CarouselDotNavigation.prototype, "previousText", void 0);
customElements.define('carousel-dot-navigation', CarouselDotNavigation);

export { CarouselDotNavigation };
